import PropTypes from 'prop-types';

import AsyncTableComponent from '../../Table/AsyncTableContainer';
import ActivitySelectContainer from '../containers/ActivitySelectContainer';

import { formatDate, replaceUnderscoreWithSpace } from '../../../utils';
import { getPropertyName } from '../utils';

import { TABLE_CONSTANTS, TABLE_ID } from '../../Table/constants';

import { DATE_RANGES_TYPES, TABLE_DATA_TYPES } from '../../../staticData';
import { limitFilter } from '../../Table/filters';

const PersonActionsLogComponent = (props) => {
  const { onLoad, onUnmount, items, getItems, listParams, listKey, buildings } =
    props;

  const columns = [
    {
      Header: 'Action',
      id: 'action',
      width: 300,
      accessor: ({ action }) => replaceUnderscoreWithSpace(action),
    },
    {
      Header: 'Description',
      id: 'description',
      accessor: ({ description }) => description,
    },
    {
      Header: 'Created at',
      id: 'created_at',
      width: 170,
      headerClassName: 'sort',
      defaultSortDesc: true,
      accessor: ({ createdAt }) => formatDate(createdAt),
    },
    {
      Header: 'Property',
      id: 'property',
      width: 300,
      accessor: (entry) => getPropertyName(entry, buildings),
    },
  ];

  const filters = [limitFilter(listParams)];
  const defaultParams = {};
  const tableDataType = TABLE_DATA_TYPES.personActionsLog;
  const action = null;
  const customFilters = (
    <ActivitySelectContainer listParams={listParams} getItems={getItems} />
  );
  const fieldsForBackendSort = [TABLE_CONSTANTS.created_at];

  return (
    <AsyncTableComponent
      tableId={TABLE_ID.personActionsLogTable}
      title="Carson Activity - Person overview"
      columns={columns}
      defaultSort={TABLE_CONSTANTS.created_at}
      fieldsForBackendSort={fieldsForBackendSort}
      filters={filters}
      showFiltersAreApplied={false}
      onLoad={onLoad}
      onUnmount={onUnmount}
      items={items}
      getItems={getItems}
      listParams={listParams}
      defaultParams={defaultParams}
      tableDataType={tableDataType}
      listKey={listKey}
      action={action}
      customFilters={customFilters}
      dateRangeType={DATE_RANGES_TYPES.created_at}
      datePicker
      manual
      defaultSortDesc
    />
  );
};

PersonActionsLogComponent.propTypes = {
  onLoad: PropTypes.func.isRequired,
  onUnmount: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  items: PropTypes.instanceOf(Object).isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  listKey: PropTypes.string.isRequired,
  buildings: PropTypes.instanceOf(Object).isRequired,
};

export default PersonActionsLogComponent;
